import { FunctionComponent } from "react";
import { IonButton, IonIcon, IonText } from "@ionic/react";
import { reload } from "ionicons/icons";
import { EditPlaceholderSiteList } from "./edit-placeholder-site-list.component";

interface EmptySiteListComponentProps {
  message: string;
  retryLabel: string;
  refreshSiteList: () => void;
}

export const EmptySiteListComponent: FunctionComponent<EmptySiteListComponentProps> = ({
  message,
  refreshSiteList,
  retryLabel,
}) => (
  <EditPlaceholderSiteList>
    <IonText>{message}</IonText>
    <IonButton className="ion-margin-top" onClick={refreshSiteList} color="medium" fill="clear">
      <IonIcon slot="icon-only" icon={reload} style={{ marginRight: 8 }} />
      {retryLabel}
    </IonButton>
  </EditPlaceholderSiteList>
);
